export default "__VITE_ASSET__C_h03$TR__"